export const getRowFields = (
  payrollType,
  employmentType,
  additionalSelectValue,
  incentives = []
) => {
  const allowanceName = incentives.length ? incentives[0].allowanceType : "";

  const commonFields = [
    "agency",
    "accountNumber",
    "surname",
    "Firstname",
    "Middlename",
    "salaryGrade",
    "email",
  ];

  const rowFieldsMap = {
    "J.O Salary": {
      Salary: [
        "increment",
        // "noOfDays",
        // "daystobeDeduc",
        // "minsToBeDeducted",
        ...commonFields.slice(0, 5),
        "salaryGrade",
        "absencesDays",
        "absencesMins",
        "overpaymentBasic",
        "flagRaising",
        "earnedPeriod",
        "threePercent",
        "twoPercent",
        "fivePercent",
        "tenPercent",
        "totalTax",
        "OtherDeduction",
        "OtherAdditional",
        "netAmountsJO",
        commonFields[6],
      ],
      "Addendum Payroll": [
        "increment",
        ...commonFields.slice(0, 5),
        "salaryGrade",
        "daystobeDeduc",
        "minsToBeDeducted",
        "absencesDays",
        "absencesMins",
        "overpaymentBasic",
        "flagRaising",
        "earnedPeriod",
        "threePercent",
        "twoPercent",
        "fivePercent",
        "tenPercent",
        "totalTax",
        "OtherDeduction",
        "netAmount",
        commonFields[6],
      ],
    },

    "Augmentation Pay": {
      Other: {
        Other: [
          "increment",
          "yesOrNo",
          "duties",
          "absencesPresent",
          "latesUndertimeMins",
          "noOfDuties",
          "absencesAugmentation",
          "latesUTAugmentation",
          ...commonFields.slice(0, 5),
          "apRate",
          "totalDuty",
          "prorated",
          "absencesLeaves",
          "utPerMinute",
          "currentAssign",
          "airportApRate",
          "amountEarnedAP",
          "airportAbsence",
          "airportLates",
          "airportDuties",
          "excessAirportDuties",
          "totalEarned",
          "overpaymentBasic",
          "flagRaising",
          "earnedAp",
          "taxAP",
          "contributions",
          "OtherDeduction",
          "OtherAdditional",
          "netAmountAP",
          commonFields[6],
        ],
      },
    },

    // "Augmentation Pay": [
    //   "increment",
    //   "daysToBeDeducted",
    //   "minsToBeDeducted",
    //   "numberOfDuty",
    //   "abs",
    //   ...commonFields.slice(0, 5),
    //   "apRate",
    //   "overpaymentBasic",
    //   "flagRaising",
    //   "totalDuty",
    //   "prorated",
    //   "absencesLeaves",
    //   "utPerMinute",
    //   "currentAssign",
    //   "airportApRate",
    //   "amountEarnedAP",
    //   "airportAbsence",
    //   "airportLates",
    //   "airportDuties",
    //   "earnedAp",
    //   "mandatoryDeductions",
    //   "OtherDeduction",
    //   "OtherAdditional",
    //   "netAmountAP",
    //   commonFields[6],
    // ],
    [allowanceName]:
      allowanceName === "Gratuity Pay"
        ? [
            "seqNo",
            ...commonFields.slice(0, 6),
            "importedData",
            "importedAdditional",
            "netPayIncentive",
          ]
        : [
            ...commonFields.slice(0, 6),
            "importedData",
            "importedAdditional",
            "netPayIncentive",
          ],
    // Handling non-Job Order
    "Basic Pay": {
      Other: {
        "Addendum Payroll": [
          "increment",
          ...commonFields.slice(0, 5),
          "salaryGrade",
          "peraAda",
          "dateofAbsence",
          "lwop",
          "dateofHalfDays",
          "daystobeDeduc",
          "halfDaystoDeduc",
          "minsToBeDeducted",
          "gsisInsuredDays",
          "dueToAbsence",
          "deducPera",
          "overpaymentBasic",
          "overpaymentPeraAda",
          "earnedBasic",
          "earnedPeraAda",
          "tax",
          "contributions",
          "OtherDeduction",
          "OtherAdditional",
          "netAmount",
          commonFields[6],
        ],
        "General Payroll": [
          "increment",
          ...commonFields.slice(0, 5),
          "salaryGrade",
          "peraAda",
          "overpaymentBasic",
          "overpaymentPeraAda",
          "earnedBasic",
          "earnedPeraAda",
          "tax",
          "contributions",
          "OtherDeduction",
          "OtherAdditional",
          "netAmount",
          commonFields[6],
        ],
        "Addendum Back-Pay": [
          "increment",
          "daysInMonth",
          "gsisInsuredDays",
          "daysTobeDeduc",
          "halfDaysTobeDeduc",
          "minutesTobeDeduc",
          "monthCovered",
          "yearCovered",
          ...commonFields.slice(0, 5),
          "salaryGrade",
          "peraAda",
          "dueToLeavesAbesnces",
          "deductionPeraAda",
          "overpaymentBasic",
          "overpaymentPeraAda",
          "earnedBasicBP",
          "earnedPeraAdaBP",
          "taxBP",
          "contributions",
          "OtherDeduction",
          "OtherAdditional",
          "netAmountBP",
          commonFields[6],
        ],
      },
    },
    "Addendum to Addendum Pay": [
      "increment",
      ...commonFields.slice(0, 5),
      "salaryGrade",
      "peraAda",
      "daysInAMonth",
      "gsisInsuredDays",
      "daystobeDeduc",
      "halfDaystoDeduc",
      "minsToBeDeducted",
      "dueToAbsence",
      "deducPera",
      "overpaymentBasic",
      "overpaymentPeraAda",
      "earnedBasic",
      "earnedPeraAda",
      "tax",
      "contributions",
      "OtherDeduction",
      "OtherAdditional",
      "netAmount",
      commonFields[6],
    ],
    "Individual Payroll": {
      Other: {
        "Initial Salary (Basic)": [
          "increment",
          "employmentStats",
          "nhStatus",
          "concatList",
          "agency",
          "accountNumber",
          "surname",
          "Firstname",
          "Middlename",
          "coverage",
          "plantillaItem",
          "salaryGrade",
          "peraAda",
          "inService",
          "date",
          "daysInAMonth",
          "weekends",
          "proratedRate",
          "proratedPera",
          "perDayFirst",
          "perMinFirst",
          "perDaySecond",
          "perMinSecond",
          "dayFirst",
          "minFirst",
          "daySecond",
          "minSecond",
          "basic",
          "dayThird",
          "minThird",
          "pera",
          "daysForGSIS",
          "basicEarned",
          "peraAdaEarned",
          "total",
          "tax",
          "contributions",
          "individualNetPay",
          commonFields[6],
        ],
        "Last Salary (Basic)": [
          "increment",
          "employmentStats",
          "nhStatus",
          "concatList",
          "agency",
          "accountNumber",
          "surname",
          "Firstname",
          "Middlename",
          "coverage",
          "plantillaItem",
          "salaryGrade",
          "peraAda",
          "inService",
          "date",
          "daysInAMonth",
          "weekends",
          "proratedRate",
          "proratedPera",
          "perDayFirst",
          "perMinFirst",
          "perDaySecond",
          "perMinSecond",
          "dayFirst",
          "minFirst",
          "daySecond",
          "minSecond",
          "basic",
          "dayThird",
          "minThird",
          "pera",
          // "daysForGSIS",
          "basicEarned",
          "peraAdaEarned",
          "total",
          "tax",
          "contributions",
          "individualNetPay",
          commonFields[6],
        ],
        "Initial Salary (AP)": [
          "increment",
          "employmentStats",
          "nhStatus",
          "concatList",
          "agency",
          "accountNumber",
          "surname",
          "Firstname",
          "Middlename",
          "plantillaItem",
          "coverage",
          "salaryGrade",
          "dailyRate",
          "perMinute",
          "daysEarned",
          "latesIncurred",
          "latesUT",
          "earnedForPeriodAP",
          "tax",
          "individualNetPay",
          commonFields[6],
        ],
        "Last Salary (AP)": [
          "increment",
          "employmentStats",
          "nhStatus",
          "concatList",
          "agency",
          "accountNumber",
          "surname",
          "Firstname",
          "Middlename",
          "plantillaItem",
          "coverage",
          "salaryGrade",
          "dailyRate",
          "perMinute",
          "daysEarned",
          "latesIncurred",
          "latesUT",
          "overpaymentBasic",
          "earnedForPeriodAP",
          "tax",
          "OtherDeduction",
          "individualNetPay",
          commonFields[6],
        ],
        "Backwage (BASIC)": [
          "increment",
          "salaryGrade",
          "rate",
          "latesAbsences",
          "totalLates",
          "proRated",
          "checking",
          "totalGross",
          "tax",
          "contributions",
          "earnedForPeriod",
          commonFields[6],
        ],
        "Initial RATA": [
          "increment",
          "rata",
          "numbersOfWorkdays",
          "actualRATA",
          "netAmountRATA",
          commonFields[6],
        ],
        "Salary Differential (Basic)": [
          "increment",
          "dateCompleted",
          "dateRec",
          "dateRealesed",
          "voucher",
          "agency",
          "code",
          "concatList",
          "accountNumber",
          "surname",
          "Firstname",
          "Middlename",
          "middleInitial",
          "coverage",
          "oldItem",
          "oldRate",
          "newItem",
          "newRate",
          "differential",
          "proRatedMonth",
          "inService",
          "date",
          "daysInMonth",
          "proRatedFirst",
          "wholeMonth",
          "earnedWhole",
          "Total",
          "Tax",
          "totalMonths",
          "netPaySD",
          "myDiff",
          "yeDiff",
          "totalSD",
        ],
      },
    },
  };

  let rowFields;
  if (
    payrollType === "Basic Pay" &&
    (additionalSelectValue === "Addendum Payroll" ||
      additionalSelectValue === "General Payroll" ||
      additionalSelectValue === "Addendum Back-Pay")
  ) {
    rowFields = rowFieldsMap?.[payrollType]?.["Other"]?.[additionalSelectValue];
  } else if (
    payrollType === "Augmentation Pay" &&
    (additionalSelectValue === "Addendum Payroll" ||
      additionalSelectValue === "General Payroll")
  ) {
    rowFields = rowFieldsMap?.[payrollType]?.["Other"]?.["Other"];
  } else if (
    payrollType === "Addendum Payroll" &&
    employmentType === "Job Order" &&
    additionalSelectValue === "Basic Pay"
  ) {
    rowFields =
      rowFieldsMap?.[payrollType]?.["Job Order"]?.[additionalSelectValue];
  } else if (
    payrollType === "Individual Payroll" &&
    employmentType !== "Job Order" &&
    (additionalSelectValue === "Initial Salary (Basic)" ||
      additionalSelectValue === "Last Salary (Basic)" ||
      additionalSelectValue === "Initial Salary (AP)" ||
      additionalSelectValue === "Last Salary (AP)" ||
      additionalSelectValue === "Backwage (BASIC)" ||
      additionalSelectValue === "Initial RATA" ||
      additionalSelectValue === "Salary Differential (Basic)")
  ) {
    rowFields = rowFieldsMap?.[payrollType]?.["Other"]?.[additionalSelectValue];
  } else if (
    payrollType === "J.O Salary" &&
    (additionalSelectValue === "Salary" ||
      additionalSelectValue === "Addendum Payroll")
  ) {
    rowFields = rowFieldsMap?.[payrollType]?.[additionalSelectValue];
  } else {
    rowFields = rowFieldsMap?.[additionalSelectValue];
  }

  if (!rowFields) {
    return [];
  }

  return rowFields;
};

export const getBorderFields = () => {
  return [
    "netAmount",
    "netAmountAP",
    "salaryGrade",
    "peraAda",
    "deductionsDueToLeaves",
    "deductionPeraAda",
    "earnedBasic",
    "earnedPeraAda",
    "tax",
    "gsis",
    "philhealth",
    "pagibig",
    "apAbsences",
    "earnedAp",
    "netAmountAP",
  ];
};
